import { Action } from '@ngrx/store';

export class StockResearchTrendAction implements Action {

    public static getTrend: string = '[Research] get_trend';
    public static getTrendError: string = '[Research] get_trend_error';
    public static getTrendSuccess: string = '[Research] get_trend_success';

    public static getShortTrend: string = '[Research] get_short_trend';
    public static getShortTrendError: string = '[Research] get_short_trend_error';
    public static getShortTrendSuccess: string = '[Research] get_short_trend_success';

    public static getCompanyTrend: string = '[Research] get_company_trend';
    public static getCompanyTrendError: string = '[Research] get_company_trend_error';
    public static getCompanyTrendSuccess: string = '[Research] get_company_trend_success';

    public static getLittleTraded: string = '[PosRisk] get_little_traded';
    public static getLittleTradedError: string = '[PosRisk] get_little_traded_error';
    public static getLittleTradedSuccess: string = '[PosRisk] get_little_traded_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
